import React from "react";
import { fetchLAdditionalInterestSkim } from "../../store/reducers/dashboardSlice/api";
import { gridColumns_additionalInterestSkim } from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";
import useFetchTableData from "../../useFetchTableData";
import { useSelector } from "react-redux";

const AdditionalInterestSkimTables = ({ className = "" }) => {
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const { data, status, retry } = useFetchTableData(
    fetchLAdditionalInterestSkim,
    "additionalInterestSkim",
    selectedRole
  );

  if (!data || data?.length === 0) {
    return null;
  }

  return (
    <CommonGrid
      className={`col-sm-6 ${className}`}
      title={"Additional Interest Yields / Skim"}
      gridColumns={gridColumns_additionalInterestSkim}
      columnData={data}
      tableTotal={["servicing_fee_monthly", "daily_per_diem"]}
      status={status}
      onRetry={retry}
    />
  );
};

export default AdditionalInterestSkimTables;
